import { calculatePublicPath } from "canopy-sofe-extensions";

__webpack_public_path__ = calculatePublicPath("login-ui");
